import React from 'react';
import { Link } from 'react-router-dom';

import './ServicesOffer.css';

const ServicesOffer = () => {
  return (
    <div className="services-offer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>Our technologies</h1>
            <p className="heading">
              NATEK specializes in designing and implementing IT business solutions to support our partners in the digital transformation. We have a broad portfolio of services and a proven track
              record of delivering solutions to highly specialized markets and industries. NATEK’s experience in delivering IT services and IT solutions enables us to provide our partners with
              technical expertise, flexibility across multiple technologies and geographies and service consistency.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-6 col-xxl-4">
            <div className="card">
              <div className="service-icon">
                <span className="icon">
                  <img src="./icons/icon_service_1.svg" alt="Service 1"></img>
                </span>
                <span className="stick stick-top"></span>
                <span className="stick stick-bottom"></span>
              </div>
              <div className="card-body">
                <h5 className="card-title">Cloud</h5>
                <p className="card-text">Short service description, text... text... text... Short service description, text... text... text... </p>
                <p className="text-end">
                  <Link to="/" className="btn btn-secondary-outline btn-sm">
                    Read more{' '}
                    <span className="chev">
                      <i className="bi bi-chevron-right"></i>
                    </span>
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xxl-4">
            <div className="card">
              <div className="service-icon">
                <span className="icon">
                  <img src="./icons/icon_service_2.svg" alt="Service 1"></img>
                </span>
                <span className="stick stick-top"></span>
                <span className="stick stick-bottom"></span>
              </div>
              <div className="card-body">
                <h5 className="card-title">Network services</h5>
                <p className="card-text">Short service description, text... text... text... Short service description, text... text... text... </p>
                <p className="text-end">
                  <Link to="/" className="btn btn-secondary-outline btn-sm">
                    Read more{' '}
                    <span className="chev">
                      <i className="bi bi-chevron-right"></i>
                    </span>
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xxl-4">
            <div className="card">
              <div className="service-icon">
                <span className="icon">
                  <img src="./icons/icon_service_3.svg" alt="Service 1"></img>
                </span>
                <span className="stick stick-top"></span>
                <span className="stick stick-bottom"></span>
              </div>
              <div className="card-body">
                <h5 className="card-title">SAP</h5>
                <p className="card-text">Short service description, text... text... text... Short service description, text... text... text... </p>
                <p className="text-end">
                  <Link to="/" className="btn btn-secondary-outline btn-sm">
                    Read more{' '}
                    <span className="chev">
                      <i className="bi bi-chevron-right"></i>
                    </span>
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xxl-4">
            <div className="card">
              <div className="service-icon">
                <span className="icon">
                  <img src="./icons/icon_service_4.svg" alt="Service 1"></img>
                </span>
                <span className="stick stick-top"></span>
                <span className="stick stick-bottom"></span>
              </div>
              <div className="card-body">
                <h5 className="card-title">Software development</h5>
                <p className="card-text">Short service description, text... text... text... Short service description, text... text... text... </p>
                <p className="text-end">
                  <Link to="/" className="btn btn-secondary-outline btn-sm">
                    Read more{' '}
                    <span className="chev">
                      <i className="bi bi-chevron-right"></i>
                    </span>
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xxl-4">
            <div className="card">
              <div className="service-icon">
                <span className="icon">
                  <img src="./icons/icon_service_5.svg" alt="Service 1"></img>
                </span>
                <span className="stick stick-top"></span>
                <span className="stick stick-bottom"></span>
              </div>
              <div className="card-body">
                <h5 className="card-title">Quality assurance</h5>
                <p className="card-text">Short service description, text... text... text... Short service description, text... text... text... </p>
                <p className="text-end">
                  <Link to="/" className="btn btn-secondary-outline btn-sm">
                    Read more{' '}
                    <span className="chev">
                      <i className="bi bi-chevron-right"></i>
                    </span>
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xxl-4">
            <div className="card">
              <div className="service-icon">
                <span className="icon">
                  <img src="./icons/icon_service_6.svg" alt="Service 1"></img>
                </span>
                <span className="stick stick-top"></span>
                <span className="stick stick-bottom"></span>
              </div>
              <div className="card-body">
                <h5 className="card-title">Customer support</h5>
                <p className="card-text">Short service description, text... text... text... Short service description, text... text... text... </p>
                <p className="text-end">
                  <Link to="/" className="btn btn-secondary-outline btn-sm">
                    Read more{' '}
                    <span className="chev">
                      <i className="bi bi-chevron-right"></i>
                    </span>
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesOffer;
